
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.782 2.48a1 1 0 00-1.697-.566l-1.302 1.302A9.955 9.955 0 0012 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10c0-1.733-.44-3.363-1.216-4.784l1.302-1.302a1 1 0 00-.566-1.697L20 4l-.218-1.52zm-2.545 5.697l1.768.252a1 1 0 00.16.01 8 8 0 11-3.605-3.605 1 1 0 00.01.16l.253 1.769-.347.346a6 6 0 101.414 1.414l.347-.346zM12 8c.742 0 1.437.202 2.032.554l-1.514 1.514a2 2 0 101.414 1.414l1.514-1.514A4 4 0 1112 8z"}})])
          )
        }
      }
    